<template>
  <v-card flat style="border-radius: 0px">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text" style="display: inline-block">
        Variazione per {{ articolo_sel.cod_articolo }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone della configurazione -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="openConfigurazioneVarianti"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-cog </v-icon>
          </v-btn>
        </template>
        <span>Configura Varianti</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="setVariante" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Genera Variante</span>
      </v-tooltip>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row align="center">
          <v-col cols="3" v-for="(parametro, i) in parametri" :key="i">
            <v-autocomplete
              dense
              hide-details
              :items="parametro.varianti"
              item-text="des"
              item-value="id_tabella"
              :label="parametro.des"
              outlined
              style="border-radius: 0px"
              v-model="std_obj[parametro.val_txt]"
            >
              <template #label>
                <span class="mr-2">{{ parametro.des }}</span>
                <span @click.stop style="min-width: 500px; pointer-events: all">
                  <Modules
                    v-on:dialogModules="getParametriVarianti"
                    :tipo="parametro.cod"
                    :nome="parametro.des"
                    setaction="settabella"
                    getaction="gettabella"
                    controller="Global"
                    :controllaCodice="true"
                    :filter="'validita = 1'"
                    :all_label="[`${parametro.des}`]"
                    :dati="[{ des: '' }]"
                  />
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" v-if="items_varianti.length > 0">
            <!-- Tabella delle varianti già esistenti -->
            <v-data-table :headers="headers_varianti" :items="items_varianti">
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Varianti Esistenti
                  </v-toolbar-title>
                </v-toolbar>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td
                    :style="{ textAlign: 'left' }"
                    v-for="(header, i) in headers_varianti"
                    :key="i"
                  >
                    <!-- Colonna del codice articolo -->
                    <template v-if="header.value == 'cod_articolo_variante'">
                      {{ item.cod_articolo_variante }}
                    </template>

                    <!-- Colonna di eliminazione -->
                    <template v-else-if="header.value == 'elimina'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickEliminaVariante(item)"
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="error"> mdi-close </v-icon>
                          </v-btn>
                        </template>
                        <span>Elimina Variante</span>
                      </v-tooltip>
                    </template>

                    <!-- Colonna standard -->
                    <template v-else>
                      {{
                        parametri.filter((p) => p.val_txt == header.value)
                          .length > 0
                          ? parametri
                              .filter((p) => p.val_txt == header.value)[0]
                              .varianti.filter(
                                (v) => v.id_tabella == item[header.value]
                              ).length > 0
                            ? parametri
                                .filter((p) => p.val_txt == header.value)[0]
                                .varianti.filter(
                                  (v) => v.id_tabella == item[header.value]
                                )[0].des
                            : ""
                          : ""
                      }}
                    </template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" v-else>
            <div
              class="elevation-2 pa-5"
              style="
                border: 1px solid black;
                border-radius: 5px;
                display: inline-block;
              "
            >
              Non ci sono ancora varianti per questo articolo.
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di configurazione varianti -->
    <v-dialog v-model="dialog_configurazione" width="700">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Configurazione Varianti
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiParametro"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo Parametro</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaConfigurazione"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Configurazione</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_configurazione = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers_configurazione"
                  :items="
                    items_configurazione_tmp.filter(
                      (elem) => elem.validita == 1
                    )
                  "
                >
                  <!-- Descrizione -->
                  <template v-slot:[`item.des`]="{ item }">
                    <v-text-field v-model="item.des"></v-text-field>
                  </template>

                  <!-- Tipo del valore -->
                  <template v-slot:[`item.cod`]="{ item }">
                    <v-text-field v-model="item.cod"></v-text-field>
                  </template>

                  <!-- Nome colonna a DB -->
                  <template v-slot:[`item.val_txt`]="{ item }">
                    <v-text-field v-model="item.val_txt"></v-text-field>
                  </template>

                  <!-- Colonna di eliminazione -->
                  <template v-slot:[`item.elimina`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="eliminaParametro(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                      </template>
                      <span>Elimina</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOOG CANCELLA MEZZO -->
    <v-dialog v-model="dialog_conferma" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          Sei sicuro di voler eliminare la variante selezionata?
        </v-card-text>
        <v-divider></v-divider>
        <v-row class="ma-0 pa-0">
          <v-col cols="6" style="text-align: right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiConfermaCancellazione"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Annulla</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" style="text-align: left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="eliminaVariante" small v-bind="attrs" v-on="on">
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </template>
              <span>Conferma</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ArticoloVarinti",
  components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
  },
  props: {
    articolo_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      std_obj: new Object(),
      variante_sel: new Object(),

      // Modal
      dialog_conferma: false,
      dialog_configurazione: false,
      overlay: false,

      // Array
      headers_configurazione: [
        {
          text: "Descrizione",
          value: "des",
        },
        {
          text: "Tipo DB",
          value: "cod",
        },
        {
          text: "Parametro DB",
          value: "val_txt",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],
      headers_varianti: new Array(),
      items_varianti: new Array(),
      items_configurazione_tmp: new Array(),
      parametri: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiParametro() {
      this.items_configurazione_tmp.push({
        id_tabella: -1,
        des: "",
        val_txt: "",
        cod: "",
        tipo: "VARIANTI_PAR",
        validita: 1,
      });
    },
    clickEliminaVariante(arg) {
      this.variante_sel = JSON.parse(JSON.stringify(arg));
      this.variante_sel.validita = 0;
      this.dialog_conferma = true;
    },
    eliminaParametro(arg) {
      arg.validita = 0;
    },
    eliminaVariante() {
      this.dialog_conferma = false;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setvariante",
          token: localStorage.user_token,
          variante: [this.variante_sel],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getVarianti();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getParametriVarianti() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "VARIANTI_PAR",
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data && res.data.length > 0) {
              // Per ogni parametro, lo inserisco nella lista dei parametri.
              this.parametri = new Array();
              res.data.forEach((elem) => {
                this.parametri.push({
                  id_tabella: elem.id_tabella,
                  des: elem.des,
                  val_txt: elem.val_txt,
                  cod: elem.cod,
                  tipo: elem.tipo,
                  validita: 1,
                  varianti: [],
                });
              });
            }

            this.$emit("update_varianti");
            this.getValoriVarianti();

            /* Registro nel mio oggetto generico che ci sono dei valori,
             * per ora resettati, che potrò modificare di volta in volta
             * selezionando le varianti. */
            this.headers_varianti = new Array();

            // Inizio a valorizzare gli headers della tabella.
            this.headers_varianti.push({
              text: "Cod. Articolo",
              value: "cod_articolo_variante",
              sortable: false,
            });

            this.parametri.forEach((parametro) => {
              this.std_obj[parametro.val_txt] = null;

              // Inserisco il parametro nelle testate della tabella.
              this.headers_varianti.push({
                text: parametro.des,
                value: parametro.val_txt,
                sortable: false,
              });
            });

            this.headers_varianti.push({
              text: "Elimina",
              value: "elimina",
              sortable: false,
              width: "100px",
            });

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );

          return false;
        });
    },
    getValoriVarianti() {
      // Se non ho parametri non proseguo.
      if (this.parametri.length == 0) return;

      // Preparo la stringa con i tipi.
      let request_string = "|";
      this.parametri.forEach((p) => {
        request_string += `,'${p.cod}'`;
      });
      request_string = request_string.replace("|,", "");

      // Chiedo al BE di darmi i tipi dei parametri.
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: request_string,
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Lego le varianti ai parametri di riferimento.
            this.parametri.forEach((p) => {
              if (res.data[p.cod] !== null && res.data[p.cod] !== undefined)
                p.varianti = res.data[p.cod];
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
        });
    },
    getVarianti() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getvarianti",
          token: localStorage.user_token,
          id_articolo: this.articolo_sel.id_articolo,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_varianti = res.data.result.varianti;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    openConfigurazioneVarianti() {
      this.items_configurazione_tmp = JSON.parse(
        JSON.stringify(this.parametri)
      );

      this.items_configurazione_tmp.forEach((elem) => {
        delete elem.varianti;
      });

      this.dialog_configurazione = true;
    },
    salvaConfigurazione() {
      // Mando solo paramteri già salvati OR validi.
      const richiesta = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          tabella: this.items_configurazione_tmp.filter(
            (elem) => elem.id_tabella > 0 || elem.validita > 0
          ),
          assistenza: 0,
        },
      };

      this.overlay = true;
      this.dialog_configurazione = false;

      this.$store
        .dispatch("api", richiesta)
        .then(async (res) => {
          this.overlay = false;
          if (res.status === 200) {
            await this.getParametriVarianti();
            this.getVarianti();
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
        });
    },
    setVariante() {
      // Controllo che tutti i campi abbiano un valore.
      let chk_valori_campi = true;
      for (let field in this.std_obj) {
        if (this.std_obj[field] == null || this.std_obj[field] == "") {
          chk_valori_campi = false;
        }
      }

      if (chk_valori_campi == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Valorizzare tutti i parametri prima di salvare."
        );
        return;
      }

      // Controllo che la nuova variante non esista già.
      let chk_variante_esistente = true;

      let str_confronto = "";
      for (let field in this.std_obj) {
        str_confronto += this.std_obj[field] + "-";
      }

      this.items_varianti.forEach((elem) => {
        let str_confronto_elem = "";
        for (let field in this.std_obj) {
          str_confronto_elem += elem[field] + "-";
        }

        if (str_confronto_elem == str_confronto) {
          chk_variante_esistente = false;
        }
      });

      if (chk_variante_esistente == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La variante risulta già esistente."
        );
        return;
      }

      // Compongo la request.
      const obj_tmp = {
        id_articolo_variante: -1,
        id_articolo: -1,
        id_articolo_root: this.articolo_sel.id_articolo,
      };

      for (let field in this.std_obj) {
        obj_tmp[field] = this.std_obj[field];
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setvariante",
          token: localStorage.user_token,
          variante: [obj_tmp],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            this.getVarianti();

            this.$refs.SnackbarQV.print(
              "success",
              "L'articolo è stato registrato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
  },
  created() {},
  async mounted() {
    await this.getParametriVarianti();
    this.getVarianti();
  },
};
</script>
<style scoped>
</style>